/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { FunctionsBaseService } from '../functions-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FunctionDto } from '../models/function-dto';

@Injectable({ providedIn: 'root' })
export class FunctionsControllerService extends FunctionsBaseService {

  /**
   * Path part for operation functionsControllerWebhook
   */
  static readonly FunctionsControllerWebhookPath = '/v1/webhook';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhook()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhook$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionsControllerService.FunctionsControllerWebhookPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhook$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhook(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<void> {

    return this.webhook$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation functionsControllerExecuteFunction
   */
  static readonly FunctionsControllerExecuteFunctionPath = '/v1/{functionId}/execute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunction$Response(params: {
    functionId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionsControllerService.FunctionsControllerExecuteFunctionPath, 'post');
    if (params) {
      rb.path('functionId', params.functionId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunction(params: {
    functionId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: {
}
  }): Observable<void> {

    return this.executeFunction$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation functionsControllerGetFunctions
   */
  static readonly FunctionsControllerGetFunctionsPath = '/v1/{scope}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFunctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFunctions$Response(params: {
    scope: 'SYSTEM' | 'MODULE' | 'ENTITY';
    scopeId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<FunctionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionsControllerService.FunctionsControllerGetFunctionsPath, 'get');
    if (params) {
      rb.path('scope', params.scope, {});
      rb.query('scopeId', params.scopeId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FunctionDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFunctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFunctions(params: {
    scope: 'SYSTEM' | 'MODULE' | 'ENTITY';
    scopeId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<FunctionDto>> {

    return this.getFunctions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FunctionDto>>) => r.body as Array<FunctionDto>)
    );
  }

}
